import type {
  HiringConfirmationAction,
  HiringConfirmationNotHiredReason,
} from '__generated__/graphql';

export type JobFeedbackAnswer = {
  jobId: number;
  action: HiringConfirmationAction;
  hiredApplications: { id: number; name: string }[];
  // Omitted on the hired path — the reducer then clears any stale not-hired reason.
  reason?: HiringConfirmationNotHiredReason | null;
  reasonText?: string | null;
};

const hiringConfirmationActions = {
  HIRING_ANSWER_SUBMITTED: 'HIRING_ANSWER_SUBMITTED',

  answerSubmitted: (answer: JobFeedbackAnswer) => ({
    type: hiringConfirmationActions.HIRING_ANSWER_SUBMITTED,
    payload: { answer },
  }),
};

export default hiringConfirmationActions;
